import { apiClient } from 'api/apiClient';
import {
  RequestSupportFormType,
  SupportRequestsFilterSearchParams,
  SupportRequestsFilterSearchParamsSchema,
} from './schema';
import {
  SupportRequestsQuery,
  SupportRequestsResponse,
  SupportRequestsResponseSchema,
} from './schema';
import { prepareSortingParams } from 'api/common-schemas';

// existing
export const postRequestSupport = async (
  body: RequestSupportFormType,
): Promise<unknown> => {
  const response = await apiClient.post(
    '/api/v1/groups/general/requests',
    body,
  );
  return response.data;
};

// NEW: list fetcher
export const getSupportRequests_temp = async (
  params: SupportRequestsQuery = {},
): Promise<SupportRequestsResponse> => {
  const response = await apiClient.get('/api/v1/groups/cases', {
    params,
  });

  // validate/guard (optional but nice)
  const parsed = SupportRequestsResponseSchema.parse(response.data);
  return parsed;
};

export const getSupportRequests = async (
  params: SupportRequestsFilterSearchParams,
): Promise<SupportRequestsResponse> => {
  const newQueryParams = prepareSortingParams(
    params,
    mapOrderColumns,
    SupportRequestsFilterSearchParamsSchema,
  );
  const response = await apiClient.get('/api/v1/groups/cases', {
    params: newQueryParams,
  });

  return response.data;
};

const mapOrderColumns = {
  id: 'Id',
  case_number: 'CaseNumber',
  status: 'Status',
  assigned_to: 'Assigned_To__c',
  account_name: 'Account.Name',
  escalated_request: 'Escalated_Request__c',
  premier_rep: 'Premier_Rep__c',
  premier_team: 'Premier_Team__c',
  ticket_type: 'Type',
  subject: 'Subject',
  issue: 'Reason',
  sub_reason: 'Sub_Reason__c',
  disputed_amount: 'Disputed_Amount__c',
  comments: 'Comments',
  latest_case_comment: 'Latest_Case_Comment__c',
  additional_emails: 'Additional_Emails__c',
  supplied_email: 'SuppliedEmail',
  supplied_name: 'SuppliedName',
  description: 'Description',
  source: 'Origin',
  priority: 'Priority',
  billing_account_id: 'vlocity_cmt__BillingAccountId__c',
  service_account_id: 'vlocity_cmt__ServiceAccountId__c',
  opened_by: 'CreatedBy.Name',
  opened: 'CreatedDate',
  last_updated: 'LastModifiedDate',
  last_modified_by: 'LastModifiedBy.Name',
};
